import React from 'react'
import { Typography } from '@mui/material'
import { ContactVariables } from '../../GlobalVariables/Contact'

const ConflictErrorModalContent = () => (
  <div data-testid="conflict-modal">
    <Typography variant="bodyLarge" component="p" mb="10px">
      An error has occurred whilst creating your MyZuto account, but don&apos;t worry, your application has been submitted. Your car buying expert will be in touch.
    </Typography>
    <Typography variant="bodyLarge" component="p">
      Alternatively, give us a call on <a href={`tel:${ContactVariables.zutoContactNumber}`}>{ContactVariables.zutoContactNumber}</a>
    </Typography>
  </div>
)

export default ConflictErrorModalContent
